import { Path, Svg } from "@react-pdf/renderer";
import React from "react";

interface Props {
    fill: string;
}

const Arrow: React.FC<Props> = ({ fill }) => {
    return (
        <Svg width="12pt" height="100%" viewBox="0 0 24 24">
            <Path
                fill={fill}
                d="M7,18a1,1,0,0,1-.89-.55,1,1,0,0,1,.44-1.34L14.76,12,6.55,7.89a1,1,0,1,1,.9-1.78l10,5a1,1,0,0,1,0,1.78l-10,5A.93.93,0,0,1,7,18Z"
            />
        </Svg>
    );
};

export default Arrow;
